function article1() {
  return {
    date: '12 May 2023',
    title: 'A Personal Experience on the Value of Transferable Skills in Software Development',
    description: 'I’ve learned to value transferable talents after switching from a career in accounting to one in software development. I’ll share my own story in this essay to show how the abilities I developed as an account clerk have aided in my career as a software engineer.',
    link: 'https://medium.com/@spencerokyere95/a-personal-experience-on-the-value-of-transferable-skills-in-software-development-ebf2cb4a2a93',
  };
}

function article2() {
  return {
    date: '12 May 2023',
    title: 'A Personal Experience on the Value of Transferable Skills in Software Development',
    description: 'I’ve learned to value transferable talents after switching from a career in accounting to one in software development. I’ll share my own story in this essay to show how the abilities I developed as an account clerk have aided in my career as a software engineer.',
    link: 'https://medium.com/@spencerokyere95/a-personal-experience-on-the-value-of-transferable-skills-in-software-development-ebf2cb4a2a93',
  };
}

const myArticles = [article1, article2];

export default myArticles;
